<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        
      </section>
      <!-- Main content -->
      <section class="content">
        <el-dialog
          title="User Verification"
          :visible.sync="dialogVisible"
          size="tiny"
          visible="false"
          :before-close="handleClose"
          v-show="showDialog"
        >
          <div class="account-box">
            <form role="form">
              <!--p class="instructionalText" style="font-weight: bold">
                Please choose the following user verification method(s) to
                verify your account:
              </p-->
              <p class="instructionalText" >
                A verification email was sent to the following email address:
                <span class="paragragh-font data-font">{{this.$route.params.user.email}}<br><br><br>
                 Please check your inbox for this email and click the link. If you don't see the email, check your spam folder.</span>
              </p>
              <!--div
                class="form-group options-alignment wrapper"
                style="align-content: center"
              >
                <a href="#" class="pull-right label-forgot"></a>
                <div class="box1">
                  <input type="checkbox" id="phone" v-model="phoneChecked" />
                  <label for="phone" style="font-size: 1vw">Phone</label>
                  <p class="paragraph-font">Text to: <br><span class="paragragh-font data-font">{{this.$route.params.user.phone}}</span></p>
                </div>
                <div class="box2">
                  <input type="checkbox" id="email" v-model="emailChecked" />
                  <label for="email" style="font-size: 1vw">Email</label>
                 <p class="paragraph-font">Send email to: <br><span class="paragragh-font data-font">{{this.$route.params.user.email}}</span></p>
                </div>
                <br />
              </div-->
              <!--button
                class="btn btn btn-primary pull-right"
                type="submit"
                v-on:click="Submit"
                
              >
                Submit
              </button-->
            </form>
            <hr />
            <!--div class="row-block">
              <div class="row"></div>
            </div-->
          </div>
        </el-dialog>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
var Auth = require("../services/Authentication/auth");
var to = require("await-to-js").default;
var db = require('../services/database/database')
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
export default {
   beforeCreate(){
    //a temp way to navigate here ONLY by the forgotPassword page- needs to be changed.
    console.log("params", this.$route.params.user)
    if(!this.$route.params.user || !this.$route.params.user === undefined){
      this.$router.push('/404')
    }
  },
  beforeMount(){
    this.Submit()
  },
  data: function () {
    return {
      dialogVisible: false,
      showDialog: true,
      phoneChecked: "",
      emailChecked: "",
    };
  },
  methods: {
    handleClose: function (done) {
      this.showDialog = false;
      this.$router.push("/login");
      // this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning'
      // })
    },
   
    Submit: async function () {
      //CLEAN THIS UP
    // const fs = require('../../firestore')
    
    // Create a new client
      const UID = this.$route.params.user.userID;
      const user = this.$route.params.user
      var emailChecked = this.emailChecked;
      var phoneChecked = this.phoneChecked;
          console.log("user UID", UID)

      // if (!emailChecked && !phoneChecked) {
      //   console.log("need to select at least one verification method");
      //   return;
      // }
     // if (emailChecked) {
        let error, result;
        [error, result] = await to(
          Auth.VerifyEmail({ UID})
        );

        if (error) {
          console.log("error", error.response);
          const errorMsg = error.response.data.error.message;
          this.$confirm("unable to verify email." + errorMsg, "Email Verification Error", {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      });
        } else if (result) {
          console.log("result", result);
        }
          
          console.log("user", user)
  //        let document = 
  //      {
  // fields: {"first_name":
  // {"stringValue": user.firstName},
  // "last_name":
  // {"stringValue": user.lastName},
  // "phone":
  // {"stringValue": user.phone},
  // "email":
  // {"stringValue": user.email},
  // "zip":
  // {"stringValue": user.zipcode},
  // "city":
  // {"stringValue": user.city},
  // "state":
  // {"stringValue": user.state},
  // "user_id":
  // {"stringValue": uuidv4()}
  // }
  // }
  //   //second argument should be the EXPIRY length of firebase's email verification link
  //    this.handleInterval(4000,9000000,UID,document, user)
     
    
//}
      },
    
    
  },
};
</script>
<style scoped>
.instructionalText {
  font-weight: "bold";
  text-align: left;
        font-size: 1.6vw;

}
.wrapper {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 1fr;
}

.options-alignment {
  padding-top: 50px;
  align-content: center;
}

.box1 {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 2;
}

.box2 {
  grid-column-start: 3;
  grid-column-end: 4;

  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 1;
}

.paragraph-font{
    font-size: 13pt;
      font-size: 1vw;

}

.data-font{
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// VerificationScreen.vue?41a0da30